<template>
  <el-dialog
    id="edit-modal"
    class="form-modal"
    :visible.sync="editVisible"
    v-loading="editProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="edit-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">View / Edit Call Group</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="editOperation" :disabled="numUsed"
            >Save</el-button
          >
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
            >Cancel</el-button
          >
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          ></el-button>
        </div>
      </div>
    </div>

    <el-form>
      <recent-audits service="Call Group" :record="selectedCallGroup" />
      <el-tabs v-model="activeTabName">
        <el-tab-pane label="General" name="general">
          <div class="inline-form-group">
            <el-col :span="11">
              <el-input
                v-model="editForm.number"
                placeholder="Call group extension"
              >
                <template slot="prefix">Call group extension</template>
                <template slot="append" v-if="numUsed">
                  <in-use :inUse="numInUse" />
                </template>
              </el-input>
            </el-col>
            <el-col :span="1" />
            <el-col :span="12">
              <el-input v-model="editForm.name" placeholder="Call group name">
                <template slot="prefix">Call group name</template>
              </el-input>
            </el-col>
          </div>

          <dads-select
            v-model="editForm.branchId"
            placeholder="Branch"
            filterable
          >
            <template slot="prefix"> Branch</template>
            <el-option
              v-for="branch in branchOptions"
              :key="branch.id"
              :value="branch.id"
              :label="branch.name"
            />
          </dads-select>

          <div class="inline-form-group">
            <el-checkbox v-model="editForm.usemoh" :label="true">
              <span>Enable music on hold</span>
            </el-checkbox>
          </div>
          <div class="inline-form-group">
            <el-checkbox v-model="editForm.checkinuse" :label="true">
              <span>Enable skipping extension if on a call</span>
            </el-checkbox>
          </div>

          <h2 class="form-section-header">Ring strategy</h2>
          <div class="mv-10">
            <el-radio-group v-model="ringStrategy" class="black-text">
              <el-radio label="RINGALL">
                <span class="black-text">Ring all</span>
              </el-radio>
              <el-radio label="SEQUENCE">
                <span class="black-text">Sequence</span>
              </el-radio>
            </el-radio-group>
          </div>
          <div class="inline-form-group" v-if="ringStrategy === 'SEQUENCE'">
            <el-checkbox v-model="enableLooping" :label="true">
              <span>Enable looping</span>
            </el-checkbox>
          </div>
          <div class="inline-form-group">
            <el-col :span="11">
              <el-select
                v-model="editForm.ringTime"
                placeholder="Select ring time (rings)"
              >
                <el-option v-for="i in 60" :key="i" :label="i" :value="i * 5" />
                <template slot="prefix">Ring time (rings)</template>
              </el-select>
            </el-col>
            <el-col :span="1" />
            <el-col :span="12" v-if="ringStrategy === 'SEQUENCE'">
              <el-select
                v-model="editForm.dialTimeout"
                placeholder="Select dial timeout (rings)"
              >
                <el-option
                  v-for="i in 120"
                  :key="i"
                  :label="i"
                  :value="i * 5"
                />
                <template slot="prefix">Dial timeout (rings)</template>
              </el-select>
            </el-col>
          </div>

          <h2 class="form-section-header">Timeout Destination</h2>
          <destination-selector
            :isTerminalDestSelector="true"
            :draggable="true"
            :showHeader="false"
            :draggableDestTypes="draggableDestTypes"
              :include-pharmacy-dests="true"
                :include-pharmacy-agents="true"
            :selectedDestinations="editForm.timeoutDestinations"
            @destinationsSelected="onTimeoutDestinationsSelection"
            title=""
            :clearFields="clearFormFields"
          />

          <h2 class="form-section-header">Unconditional forwarding</h2>
          <el-checkbox v-model="editForm.unconditionalStatus"
            >Enable unconditional forwarding</el-checkbox
          >
          <div v-if="editForm.unconditionalStatus">
            <h2 class="form-section-header">Unconditional Destinations</h2>
            <destination-selector
              :isTerminalDestSelector="true"
              :draggable="true"
              :showHeader="false"
              :draggableDestTypes="draggableDestTypes"
              :include-pharmacy-dests="true"
                :include-pharmacy-agents="true"
              :selectedDestinations="editForm.unconditionalDestinations"
              :clearFields="clearFormFields"
              @destinationsSelected="onUnconditionalDestinationsSelection"
              title=""
            />
          </div>

          <div v-if="editForm.phoneNums.length">
            <h2 class="form-section-header">Assigned phone numbers</h2>
            <el-select
              v-model="editForm.phoneNums"
              multiple
              placeholder=""
              :disabled="true"
            >
              <template slot="prefix">
                <span style="opacity: 0">Numbers</span>
              </template>
              <el-option
                v-for="item in numberOptions"
                :key="item.key"
                :label="item.label | formatNumber"
                :value="item.key"
              />
            </el-select>
            <el-tag class="mb-10">
              <i class="el-icon-info" style="margin-right: 4px"></i>
              You can modify this in the phone numbers section
            </el-tag>
          </div>
        </el-tab-pane>
        <!-- DESTINATIONS -->
        <el-tab-pane label="Destinations" name="destinations">
          <destination-selector
            :maxDests="maxDests"
            :draggable="true"
            :draggableDestTypes="['CUSTOM', 'EXT']"
            :selectedDestinations="editForm.destinations"
            :clearFields="clearFormFields"
            @destinationsSelected="onDestinationsSelection"
            title=""
          />
        </el-tab-pane>
      </el-tabs>
    </el-form>

    <destination-references
      :tenantId="selectedCallGroup ? selectedCallGroup.tenantId : null"
      type="HUNTLIST"
      :id="selectedCallGroup ? selectedCallGroup.id : null"
      :clearState="clearFormFields"
    />
  </el-dialog>
</template>

<script>
import { isEqual } from "lodash";
import DestinationSelector from "@/components/DestinationSelector.vue";
import DestinationReferences from "@/components/DestinationReferences";
import RecentAudits from "@/components/RecentAudits";
import InUse from "@/components/InUse.vue";
import DadsSelect from "@/components/select";

export default {
  name: "HuntListEditForm",

  props: {
    editVisible: { required: true },
    numInUse: { required: true },
    numberOptions: { required: true },
    clearFormFields: { required: true },
    selectedCallGroup: { required: true },
    editProcessing: { required: true },
    draggableDestTypes: { required: true },
    branchOptions: { required: true },
  },

  components: {
    DestinationSelector,
    DestinationReferences,
    RecentAudits,
    InUse,
    DadsSelect,
  },

  data() {
    return {
      dialTimeout: null,
      activeTabName: "general",
      ringStrategy: "",
      enableLooping: false,
      initialCallGroupNumber: null,
      ringTime: null,
      requestConfirm: false,
      editForm: {
        tenantId: null,
        number: null,
        name: "",
        ringTime: null,
        type: "",
        dialTimeout: null,
        usemoh: false,
        checkinuse: false,
        destinations: [],
        phoneNums: [],
        phoneNumsChanged: false,
        timeoutDestinations: [],
        unconditionalDestinations: [],
        unconditionalStatus: "",
        requestConfirm: false,
        branchId: null,
      },
    };
  },

  computed: {
    callGroupNumber() {
      return this.editForm.number;
    },

    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    maxDests() {
      return this.ringStrategy === "RINGALL" ? 50 : 75;
    },

    numUsed() {
      return this.numInUse && this.numInUse.inUse;
    },
  },

  watch: {
    dialTimeout(val) {
      if (val) this.editForm.dialTimeout = val * 5;
    },

    ringTime(val) {
      if (val) this.editForm.ringTime = val * 5;
    },

    selectedCallGroup(val) {
      if (val) {
        const {
          tenantId,
          name,
          number,
          ringTime,
          type,
          dialTimeout,
          usemoh,
          checkinuse,
          phoneNums,
          unconditionalStatus,
          destinations,
          timeoutDestinations,
          unconditionalDestinations,
          requestConfirm,
          branchId,
        } = val;

        this.editForm.destinations = [...destinations];
        this.editForm.timeoutDestinations = [...timeoutDestinations];
        this.editForm.unconditionalDestinations = [
          ...unconditionalDestinations,
        ];

        this.editForm.unconditionalStatus = !!unconditionalStatus;
        this.requestConfirm = !!requestConfirm;

        this.editForm.name = name;
        this.editForm.number = number;
        this.initialCallGroupNumber = number;
        this.editForm.type = type;
        this.ringStrategy = type;
        this.editForm.tenantId = tenantId;

        if (branchId) {
          this.editForm.branchId = branchId;
        }

        if (type === "CYCLE") {
          this.ringStrategy = "SEQUENCE";
        }

        this.ringTime = ringTime / 5;
        this.dialTimeout = dialTimeout / 5;

        this.editForm.checkinuse = checkinuse === "on";

        this.editForm.usemoh = usemoh === "on";
        if (type === "CYCLE") this.enableLooping = true;

        if (phoneNums && phoneNums.length) {
          this.editForm.phoneNums = phoneNums.map((num) => num.id);
        }
      }
    },

    clearFormFields(value) {
      if (value) {
        this.clearFields();
      }
    },

    callGroupNumber(num) {
      if (num && num !== this.initialCallGroupNumber) {
        this.$emit("numberChange", this.callGroupNumber);
      }
    },
  },

  methods: {
    onPhoneNumsChanged() {
      let tempArray = this.selectedCallGroup.phoneNums.map((t) => {
        return t.id;
      });

      if (!isEqual(tempArray, this.editForm.phoneNums)) {
        this.editForm.phoneNumsChanged = true;
      } else {
        this.editForm.phoneNumsChanged = false;
      }
    },

    onTimeoutDestinationsSelection(destinations) {
      this.editForm.timeoutDestinations = [...destinations];
    },

    onUnconditionalDestinationsSelection(destinations) {
      this.editForm.unconditionalDestinations = [...destinations];
    },

    onDestinationsSelection(destinations) {
      this.editForm.destinations = [...destinations];
    },

    validateDestinations(destinations, type) {
      if (destinations.length > 1 && destinations.find((dst) => !dst.id)) {
        this.$notify({
          title: `Empty ${type} Destination field`,
          message: "Don't leave any destination field to be empty.",
          type: "error",
        });
        return;
      }

      let finalDestinations = [];
      if (destinations.length === 1 && destinations[0].id === null) {
        return finalDestinations;
      }

      if (destinations.length) {
        destinations.forEach((dst, idx) => (dst.order = idx + 1));

        finalDestinations = destinations.map(({ id, type, order }) => ({
          id,
          type,
          order,
        }));
      }
      return finalDestinations;
    },

    editOperation() {
      this.editForm.tenantId = this.selectedTenant.id;

      if (this.ringStrategy === "RINGALL") {
        this.editForm.dialTimeout = 300;
        this.enableLooping = false;
      }

      this.editForm.type = this.ringStrategy;
      this.editForm.type = this.enableLooping ? "CYCLE" : this.editForm.type;
      this.editForm.requestConfirm = this.requestConfirm ? "on" : "";

      const editBody = { ...this.editForm };

      const destinations = this.validateDestinations(
        editBody.destinations,
        "DESTINATIONS"
      );
      const timeoutDestinations = this.validateDestinations(
        editBody.timeoutDestinations,
        "TIMEOUT"
      );
      const unconditionalDestinations = this.validateDestinations(
        editBody.unconditionalDestinations,
        "UNCONDITIONAL"
      );

      if (timeoutDestinations && destinations && unconditionalDestinations) {
        editBody.timeoutDestinations = timeoutDestinations;
        editBody.unconditionalDestinations = unconditionalDestinations;
        editBody.destinations = destinations.slice(0, this.maxDests);
      } else {
        return;
      }

      //mutate unconditional dest to string
      editBody.unconditionalStatus = editBody.unconditionalStatus ? "on" : "";

      this.$emit("editOperation", editBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "edit");
    },

    clearFields() {
      this.editForm = {
        tenantId: null,
        number: null,
        name: "",
        ringTime: null,
        type: "",
        usemoh: false,
        checkinuse: false,
        destinations: [],
        phoneNums: [],
        dialTimeout: null,
        phoneNumsChanged: false,
        timeoutDestinations: [],
        unconditionalStatus: "",
        unconditionalDestinations: [],
        branchId: null,
      };

      this.dialTimeout = null;
      this.ringTime = null;

      this.initialCallGroupNumber = null;
      this.activeTabName = "general";
      this.ringStrategy = "";
      this.enableLooping = false;

      this.$emit("formsCleared");
    },

    remoteMethodForAvailableNums(query) {
      this.$emit("remoteMethodForAvailableNums", query);
    },
  },

  filters: {
    formatNumber(value) {
      return `(${value.substr(0, 3)}) ${value.substr(3, 3)}-${value.substr(
        6,
        4
      )}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";

.checkbox-group {
  max-width: 600px;
  margin: auto;
}

.el-tabs {
  max-width: 600px;
  margin: auto;
}

.inline-form-group .el-checkbox {
  margin-left: 0;
}

.el-checkbox {
  margin-left: 0;
}
</style>
